<td colspan="{{colspan}}" >
    <span class="badge">{{messages.length}}</span>
    <strong class="type">{{type}}{{ifPlural messages.length}}</strong>
    <ol>
    {{#messages}}
		<li class="message">{{this}}</li>
    {{/messages}}
    </ol>
</td>
